import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Head from 'next/head';
import styles from '../styles/Home.module.css';
import Image from 'next/image';
import Link from 'next/link';
import SocialMediaLinks from "../components/socialmedialinks";
export default function Home() {
  var d = new Date();
  var year = d.getFullYear();
  var address = '151 N. 7th Street Grover Beach, CA 93433';
  var googleMap = "https://www.google.com/maps/place/Lil'+Bits+Café/@35.1221622,-120.6254756,17z/data=!3m1!4b1!4m5!3m4!1s0x80ec5934f578eadd:0x2c0bf46848f1e5ab!8m2!3d35.1221532!4d-120.6232002";
  var hours = 'Open Every Day, 7:00 AM – 2:00 PM';
  var phone = '1-805-489-8615';
  var company = "Lil'Bits Cafe";
  var city = 'Grover Beach';
  var state = 'California';
  var description = "".concat(company, ", serving breakfast and lunch in ").concat(city, ", ").concat(state, ".");
  return /*#__PURE__*/_jsxs("div", {
    className: styles.container,
    children: [/*#__PURE__*/_jsxs(Head, {
      children: [/*#__PURE__*/_jsxs("title", {
        children: [company, ", ", city, ", ", state]
      }), /*#__PURE__*/_jsx("link", {
        rel: "shortcut icon",
        href: "favicon.ico"
      }), /*#__PURE__*/_jsx("link", {
        rel: "icon",
        type: "image/x-icon",
        sizes: "16x16 32x32",
        href: "favicon.ico"
      }), /*#__PURE__*/_jsx("link", {
        rel: "apple-touch-icon",
        sizes: "152x152",
        href: "favicon-152-precomposed.png"
      }), /*#__PURE__*/_jsx("link", {
        rel: "apple-touch-icon",
        sizes: "144x144",
        href: "favicon-144-precomposed.png"
      }), /*#__PURE__*/_jsx("link", {
        rel: "apple-touch-icon",
        sizes: "120x120",
        href: "favicon-120-precomposed.png"
      }), /*#__PURE__*/_jsx("link", {
        rel: "apple-touch-icon",
        sizes: "114x114",
        href: "favicon-114-precomposed.png"
      }), /*#__PURE__*/_jsx("link", {
        rel: "apple-touch-icon",
        sizes: "180x180",
        href: "favicon-180-precomposed.png"
      }), /*#__PURE__*/_jsx("link", {
        rel: "apple-touch-icon",
        sizes: "72x72",
        href: "favicon-72-precomposed.png"
      }), /*#__PURE__*/_jsx("link", {
        rel: "apple-touch-icon",
        sizes: "57x57",
        href: "favicon-57.png"
      }), /*#__PURE__*/_jsx("link", {
        rel: "icon",
        sizes: "32x32",
        href: "favicon-32.png"
      }), /*#__PURE__*/_jsx("meta", {
        name: "msapplication-TileColor",
        content: "#FFFFFF"
      }), /*#__PURE__*/_jsx("meta", {
        name: "msapplication-TileImage",
        content: "favicon-144.png"
      }), /*#__PURE__*/_jsx("meta", {
        name: "theme-color",
        content: "#ffffff"
      }), /*#__PURE__*/_jsx("link", {
        rel: "manifest",
        href: "manifest.json"
      }), /*#__PURE__*/_jsx("link", {
        rel: "icon",
        sizes: "192x192",
        href: "favicon-192.png"
      }), /*#__PURE__*/_jsx("meta", {
        name: "description",
        content: description
      })]
    }), /*#__PURE__*/_jsxs("main", {
      className: styles.main,
      children: [/*#__PURE__*/_jsx(Image, {
        src: "/logo.png",
        alt: company,
        width: 273,
        height: 159
      }), /*#__PURE__*/_jsxs("h2", {
        children: ["In beautiful ", city, ", California!"]
      }), /*#__PURE__*/_jsx("h2", {
        children: hours
      }), /*#__PURE__*/_jsx("h2", {
        children: phone
      }), /*#__PURE__*/_jsx("h3", {
        children: /*#__PURE__*/_jsx(Link, {
          href: googleMap,
          children: /*#__PURE__*/_jsx("a", {
            title: "Map it!",
            rel: "noreferrer",
            target: "_blank",
            children: address
          })
        })
      }), /*#__PURE__*/_jsx(Image, {
        src: "/4.jpg",
        alt: "Lil'Bits Cafe has great food!",
        width: 1000,
        height: 688
      }), /*#__PURE__*/_jsxs("p", {
        className: styles.caption,
        children: ["Serving Breakfast & Lunch in ", city, ", ", state, "."]
      }), /*#__PURE__*/_jsx(SocialMediaLinks, {})]
    }), /*#__PURE__*/_jsxs("footer", {
      className: styles.footer,
      children: [/*#__PURE__*/_jsx("img", {
        src: "/logo.png",
        alt: company,
        className: styles.logo
      }), /*#__PURE__*/_jsxs("p", {
        children: ["\xA9 ", year, " ", company]
      }), /*#__PURE__*/_jsx("p", {
        className: styles.footerAddress,
        children: /*#__PURE__*/_jsx(Link, {
          href: googleMap,
          children: /*#__PURE__*/_jsx("a", {
            title: "Map it!",
            rel: "noreferrer",
            target: "_blank",
            children: address
          })
        })
      })]
    })]
  });
}